import { useMutation } from 'react-query'
import { UseMutationOptions } from 'react-query/types/react/types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { uploadFile, Data } from 'hooks/queries/workspaces/useUploadFileToS3'

export type Options = Omit<UseMutationOptions<Data[], unknown, Variables>, 'mutationKey' | 'mutationFn'>

type Variables = {
  files: File[]
  folderId: string
}

export const useUploadFilesToS3 = (options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  return useMutation<Data[], unknown, Variables>(
    ['workspace', currentWorkspaceId, 'uploadFiles'],
    async ({ files, folderId }) => {
      const promises: Promise<Data>[] = []
      files.forEach((file) => {
        promises.push(uploadFile({ workspaceId: currentWorkspaceId, file, folderId }))
      })
      return Promise.all(promises)
    },
    {
      ...options,
    },
  )
}
